import {CqdbMaterial, CqdbMaterialsTableType} from '../types'

// Transforms CqdbMaterial DTOs into a table format suitable for display
export const prepareCqdbMaterialsTableFromDto = (
  materials: CqdbMaterial[],
  unitLabel: string = 'Unit'
): CqdbMaterialsTableType => {
  const keys = new Set<string>()

  materials.forEach((material) => {
    material.values?.forEach((valueRecord) => {
      keys.add(valueRecord.hourGroup)
    })
  })

  const hourKeys = Array.from(keys).sort()

  // Define table columns with material name and hour keys (e.g., "05:00", "05:30", "06:00", "06:30", ...)
  const columns = [
    {
      id: 'name',
      label: ''
    },
    {
      id: 'unit',
      label: unitLabel
    },
    ...hourKeys.map((k) => ({
      id: k,
      label: k
    }))
  ]

  // Define table rows by flattening value records for each hour keys
  const rows = materials.map((material) => {
    const mergedValues: Record<string, number> = {}

    material.values?.forEach((valueRecord) => {
      mergedValues[valueRecord.hourGroup] = Math.round(valueRecord.value * 100) / 100
    })

    return {
      name: material.materialName,
      unit: material.unit,
      ...mergedValues
    }
  })

  return {columns, rows}
}
